import {
  API_GET_MY_JOB,
  API_GET_JOB_FOR_TECH,
  API_GET_MY_JOB_PAG,
  API_GET_MY_JOB_PAG2,
  API_GET_JOB_FOR_TECH_UUID,
  API_LINKS_FOR_JOB,
  API_DELETE_JOB
} from '../config';
import { switch_api } from './switch_api';

export function getClientJobs() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_MY_JOB }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getJobUuid(uuid) {
  let token =  localStorage.getItem('token')
  return  fetch(switch_api(API_GET_JOB_FOR_TECH_UUID(uuid)), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Token '+token,
      'Content-Type': 'application/json; charset=utf-8'
    },
    credentials: 'include'
  })
  .then((response) => {
    if (!response.ok) {
      console.error("Failed loading { API_GET_JOB_FOR_TECH_UUID }: " + response.statusText);
    }
    return response;
  })
  .then((response) => response.json())
  // .then((json) => dispatch({type: 'GET_JOB', json}))
  .catch((e) => {
    // dispatch(userLoggedInFailure('' + e))
  })
}

export function getTechJobs() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB_PAG), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_JOB_FOR_TECH }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((jobs) => {
      localStorage.setItem('techJobs', JSON.stringify(jobs));
      return jobs;
    })
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getTechJobs2(date_from, date_to) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_GET_MY_JOB_PAG2(date_from, date_to)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_JOB_FOR_TECH }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((jobs) => {
      localStorage.setItem('techJobs', JSON.stringify(jobs));
      return jobs;
    })
    .then((json) => dispatch({type: 'GET_JOBS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function getLinks(uuid) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_LINKS_FOR_JOB(uuid)), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LINKS_FOR_JOB }: " + response.statusText);
        dispatch({type: 'NO_LINKS'})
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => dispatch({type: 'GET_LINKS', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function deleteJob(uuid) {
  let token = localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_DELETE_JOB(uuid)), {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed deleting { API_DELETE_JOB }: " + response.statusText);
        dispatch(getTechJobs());
      }
      return response;
    })
    .then(() => dispatch(getTechJobs()))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/jobs.js